import React from 'react';
import {faEnvelope, faLocationDot, faPhone} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col } from "react-bootstrap";
import facebook from "../../images/facebook.png";
import instagram from "../../images/instagram.png";
import youtube from "../../images/youtube.png";
import {useNavigate} from "react-router-dom";
import sksLogo from "../../images/sksLogo.png";
import CustomerSupportIcon from "../../images/customer-service-64.png";
import CustomerSupportIconTT from "../../images/customer-service-32.png";
import ReturnParcelIcon from "../../images/parcel64.png";
import ReturnParcelIconTT from "../../images/Parcel32.png";
import OrderStatusIcon from "../../images/delivery-64.png";
import OrderStatusIconTT from "../../images/delivery-32.png";
const isMobile = window.innerWidth <= 440;

const Footer = () => {
    const navigate = useNavigate();
    const handleNavigation = (path) => {navigate(path);};
    return (
        <>
            {isMobile ?(
                <Row className="mt-5 justify-content-center service-banner p-lg-5 pb-md-5 pb-0">
                    {[
                        {img:CustomerSupportIconTT , text: "Customer Support",},
                        {img:ReturnParcelIconTT, text: "Easy Return Policy"},
                        {img:OrderStatusIconTT, text: "Check Your Order Status"}
                    ].map((item, index) => (
                        <Col lg={3} md={3} sm={3} xs={3} key={index} className="text-center mb-4">
                            <div className="service-card">
                                <img src={item.img} alt={item.text} className="service-img" loading="lazy" />
                                <p className="mt-3 fw-semibold service-text fs-14 ">{item.text}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            ):(
                <Row className="mt-5 justify-content-center service-banner pt-md-4 pb-0">
                    {[
                        {img:CustomerSupportIcon , text: "Customer Support",},
                        {img:ReturnParcelIcon, text: "Easy Return Policy"},
                        {img:OrderStatusIcon, text: "Check Your Order Status"}
                    ].map((item, index) => (
                        <Col lg={3} md={3} sm={3} xs={3} key={index} className="text-center mb-4">
                            <div className="service-card">
                                <img src={item.img} alt={item.text} className="service-img" loading="lazy" />
                                <p className="mt-3 fw-semibold service-text fs-14 ">{item.text}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            )}
        <div className="footer-container mx-lg-4">
            <Row className="m-0 margin-bottom">
                <Col md={12} className="d-flex justify-content-center">
                    <img src={sksLogo} width="150px" alt="SKS Logo" loading="lazy"/>
                </Col>
            </Row>
            <Row className="mb-4 m-0 text-center">
                <Col lg={4} className="d-flex justify-content-center align-items-center mb-3 mb-lg-0">
                        <span className="address-custom-margin-right address-custom-margin-top">
                            <FontAwesomeIcon icon={faLocationDot} className="fs-20 text-green" />
                        </span>
                    <div className="mt-3 fs-14 footer-details">Opposite Al-Noor Little School Nomania Road Gujranwala</div>
                </Col>
                <Col lg={4} className="d-flex justify-content-center align-items-center mb-3 mb-lg-0">
                        <span className="me-3">
                            <FontAwesomeIcon className="fs-20 text-green" icon={faPhone} />
                        </span>
                    <div className="footer-details">(+92) 305 4973841</div>
                </Col>
                <Col lg={4} className="d-flex justify-content-center align-items-center mb-3 mb-lg-0">
                        <span className="me-3">
                            <FontAwesomeIcon className="fs-20 text-green" icon={faEnvelope} />
                        </span>
                    <div className="footer-details">info@sksfans.com</div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col md={12} className="d-flex justify-content-center">
                    <ul className="d-flex justify-content-center align-items-center p-0 m-0 custom-portal-footer-menu">
                        <li className="portal-footer-menu d-inline-block lh-sm text-decoration-none py-0 px-4">
                            <a onClick={() => handleNavigation("/")}>Home</a>
                        </li>
                        <li className="portal-footer-menu d-inline-block lh-sm text-decoration-none py-0 px-4">
                            <a onClick={() => handleNavigation("/products")}>Products</a>
                        </li>
                        <li className="portal-footer-menu d-inline-block lh-sm text-decoration-none py-0 px-4">
                            <a onClick={() => handleNavigation("/about-us")}>About Us</a>
                        </li>
                        <li className="portal-footer-menu d-inline-block lh-sm text-decoration-none py-0 px-4">
                            <a onClick={() => handleNavigation("/contact-us")}>Contact Us</a>
                        </li>
                        <li className="portal-footer-menu d-inline-block lh-sm text-decoration-none py-0 px-4">
                            <a onClick={() => handleNavigation("/terms-of-use")}>Term Of Use</a>
                        </li>
                        <li className="portal-footer-menu d-inline-block lh-sm text-decoration-none py-0 px-4" style={{borderRight:"none"}}>
                            <a onClick={() => handleNavigation("/privacy-policy")}>Privacy Policy</a>
                        </li>
                    </ul>
                </Col>
            </Row>
            <Row className="mb-4 mt-4">
                <Col md={12} className="d-flex justify-content-center">
                    <div className="mx-3">
                        <a href="https://www.facebook.com/share/1AWcNkY2uK/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
                            <img className="social-icon" src={facebook} alt="Facebook Logo" loading="lazy"/>
                        </a>
                    </div>
                    <div className="mx-3">
                        <a href="" target="_blank" rel="noreferrer">
                            <img className="social-icon" src={youtube} alt="Youtube Logo" loading="lazy" />
                        </a>
                    </div>
                    <div className="mx-3">
                        <a href="https://www.instagram.com/sksfansofficial" target="_blank" rel="noreferrer">
                            <img className="social-icon" src={instagram} alt="Instagram Logo" loading="lazy"/>
                        </a>
                    </div>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md={12} xs={12} sm={12} lg={12} className="d-flex justify-content-center align-items-center flex-wrap">
                    <p className="custom-fs-12 fs-14">All Rights reserved 2026 - © SKS (Pvt) Ltd</p>
                </Col>
            </Row>
        </div>
        </>
    );
};
export default Footer;
